import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

const initialState={
    productList:[],
    productSummaryList:[],
    productSymmaryListpage:[],
    ProductsSummaryPopularL:[],
    productSymmaryListpageCatID:[],
    productSymmaryListpageCatID_selected: null,
    productOptions:null,
    selectedProduct: null,
    registerstatus:'failure',
    editstatus:'failure',
    deleteStatus:'failure',
    status:"idle",
    productListStatus: "idle",
    productSummaryListStatus: "idle",
    productSymmaryListpageStatus: "idle",
    ProductsSummaryPopularLStatus: "idle",
    productSymmaryListpageCatIDStatus: "idle",
    productOptionsStatus: "idle",
    selectedProductStatus: "idle",
    error:''
}

export const fetchProducts=createAsyncThunk('products/fetchProducts', async ()=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/products/getProducts',
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const fetchProductOptions=createAsyncThunk('products/fetchProductOptions', async ()=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/products/options',
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const fetchProductsSummary=createAsyncThunk('products/fetchProductsSummary', async ()=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/products/getProductsSummary',
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const fetchProductsSummaryPopular=createAsyncThunk('products/fetchProductsSummaryPopular', async ()=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/products/getPopularProducts/3',
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const fetchProductsSummaryPages=createAsyncThunk('products/fetchProductsSummaryPages', async ({pagenumber,pagesize})=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/products/getProductsSummaryp/${pagenumber}/${pagesize}`,
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json',
                'Access-Control-Allow-Origin': 'http://localhost:3000',
                'Access-Control-Allow-Credentials': 'true'
            }
        }
    )
    return response.json()
})

export const fetchProductsSummaryPByCategoryID=createAsyncThunk('products/fetchProductsSummaryPByCategoryID', async ({catid,pagenumber,pagesize})=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/products/getProductsSummarypByCategoryId/${catid}/${pagenumber}/${pagesize}`,
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json',
                'Access-Control-Allow-Origin': 'http://localhost:3000',
                'Access-Control-Allow-Credentials': 'true'
            }
        }
    )
    return response.json()
})

export const fetchProductByID=createAsyncThunk('products/fetchProductByID', async (id)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/products/getProductById/${id}`,
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const CreateProduct = createAsyncThunk('products/createProduct', async (productData)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/products/addProduct',
        {
            method:'POST',
            body: JSON.stringify(productData),
            headers:{
                'Content-Type' : 'application/json',
                'Authorization': `Basic ${auth}`,
                // 'Access-Control-Allow-Origin' : 'true'
            }
        }
    )
    return await response.json();
})

export const UpdateProduct = createAsyncThunk('products/updateProduct', async ({pid,productData})=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/products/updateProduct/${pid}`,
        {
            method:'POST',
            body: JSON.stringify(productData),
            headers:{
                'Content-Type' : 'application/json',
                'Authorization': `Basic ${auth}`,
                // 'Access-Control-Allow-Origin' : 'true'
            }
        }
    )
    return await response.json();
})

export const DeleteProduct = createAsyncThunk('products/deleteProduct', async (id)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/products/deleteProduct/${id}`,
        {
            method:'GET',
            headers:{
                'Authorization': `Basic ${auth}`,
                // 'Access-Control-Allow-Origin' : 'true'
            }
        }
    )
    return await response.json();
})

const productSlice=createSlice({
    name:"products",
    initialState,
    reducers:{
        changeRegisterStatus:(state)=>{
            state.registerstatus='failure';
        },
        changeEditStatus:(state)=>{
            state.editstatus='failure';
        },
        changeDeleteStatus:(state)=>{
            state.deleteStatus='failure';
        }
    },
    extraReducers:(builder)=>{
        builder
            .addCase(fetchProducts.pending,(state)=>{
                state.productListStatus='loading';
            })
            .addCase(fetchProducts.fulfilled,(state,action)=>{
                state.productListStatus='succeeded';
                state.productList=action.payload;
            })
            .addCase(fetchProducts.rejected, (state, action) => {
            state.productListStatus = 'error';
            state.error = state.error.message || 'Failed to fetch products';
            })
            .addCase(fetchProductOptions.pending,(state)=>{
                state.status='loading';
            })
            .addCase(fetchProductOptions.fulfilled,(state,action)=>{
                state.status='succeeded';
                state.productOptions=action.payload;
            })
            .addCase(fetchProductOptions.rejected, (state, action) => {
                state.status = 'error';
                state.error = state.error.message || 'Failed to fetch product Options';
            })
            .addCase(fetchProductsSummary.pending,(state)=>{
                state.productSummaryListStatus='loading';
            })
            .addCase(fetchProductsSummary.fulfilled,(state,action)=>{
                state.productSummaryListStatus='succeeded';
                state.productSummaryList=action.payload;
            })
            .addCase(fetchProductsSummary.rejected, (state, action) => {
                state.productSummaryListStatus = 'error';
                state.error = state.error.message || 'Failed to fetch product summary';
            })
            .addCase(fetchProductsSummaryPopular.pending,(state)=>{
                state.ProductsSummaryPopularLStatus='loading';
            })
            .addCase(fetchProductsSummaryPopular.fulfilled,(state,action)=>{
                state.ProductsSummaryPopularLStatus='succeeded';
                state.ProductsSummaryPopularL=action.payload;
            })
            .addCase(fetchProductsSummaryPopular.rejected, (state, action) => {
                state.ProductsSummaryPopularLStatus = 'error';
                state.error = state.error.message || 'Failed to fetch products';
            })
            .addCase(fetchProductsSummaryPages.pending,(state)=>{
                state.status='loading';
            })
            .addCase(fetchProductsSummaryPages.fulfilled,(state, action)=>{
                state.status='succeeded';
                state.productSymmaryListpage=action.payload;
            })
            .addCase(fetchProductsSummaryPages.rejected, (state, action) => {
                state.status = 'error';
                state.error = state.error.message || 'Failed to fetch products';
            })
            .addCase(fetchProductsSummaryPByCategoryID.pending,(state)=>{
                state.status='loading';
            })
            .addCase(fetchProductsSummaryPByCategoryID.fulfilled,(state, action)=>{
                state.status='succeeded';
                state.productSymmaryListpageCatID=action.payload;
                state.productSymmaryListpageCatID_selected= action.meta.arg.catid;
            })
            .addCase(fetchProductsSummaryPByCategoryID.rejected, (state, action) => {
                state.status = 'error';
                state.error = state.error.message || 'Failed to fetch products';
            })
            .addCase(fetchProductByID.pending,(state)=>{
                state.status='loading';
            })
            .addCase(fetchProductByID.fulfilled,(state, action)=>{
                state.status='succeeded';
                state.selectedProduct=action.payload;
            })
            .addCase(fetchProductByID.rejected, (state, action) => {
                state.status = 'error';
                state.error = state.error.message || 'Failed to fetch products';
            })
            .addCase(CreateProduct.pending,(state)=>{
                state.registerstatus='loading';
            })
            .addCase(CreateProduct.fulfilled,(state, action)=>{
                state.registerstatus='succeeded';
            })
            .addCase(CreateProduct.rejected, (state, action) => {
                state.registerstatus = 'error';
                state.error = state.error.message || 'Failed to fetch products';
            })
            .addCase(UpdateProduct.pending,(state)=>{
                state.editstatus='loading';
            })
            .addCase(UpdateProduct.fulfilled,(state, action)=>{
                state.editstatus='succeeded';
            })
            .addCase(UpdateProduct.rejected, (state, action) => {
                state.editstatus = 'error';
                state.error = state.error.message || 'Failed to fetch products';
            })
            .addCase(DeleteProduct.pending,(state)=>{
                state.deleteStatus='loading';
            })
            .addCase(DeleteProduct.fulfilled,(state, action)=>{
                state.deleteStatus='succeeded';
            })
            .addCase(DeleteProduct.rejected, (state, action) => {
                state.deleteStatus = 'error';
                state.error = state.error.message || 'Failed to fetch products';
            })
    }
})

export default productSlice.reducer;